import { AccountIcon, Box } from '@iheartjane/reefer';

import { CountDot } from '@jane/shared/components';

export const UserIcon = ({
  inProgressReservations,
  pendingCashBack,
}: {
  inProgressReservations: number;
  pendingCashBack?: number | string;
}) => {
  return (
    <Box position="relative" m={12}>
      <AccountIcon color="primary" />
      {!!inProgressReservations && (
        <CountDot
          ariaLabel="active reservations"
          count={inProgressReservations}
        />
      )}
      {!inProgressReservations && !!pendingCashBack && (
        <CountDot ariaLabel="pending cash back" gold count={'$'} />
      )}
    </Box>
  );
};
